var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H17",
    stroke: "#1E232C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 8.14286L7.29289 13.5642C7.10536 13.7518 7 14.0061 7 14.2714V15C7 15.5523 7.44772 16 8 16H8.72864C8.99386 16 9.24821 15.8946 9.43575 15.7071L14.8571 10.2857M12.7143 8.14286L14.15 6.70711C14.5406 6.31658 15.1737 6.31658 15.5642 6.70711L16.2929 7.43575C16.6834 7.82627 16.6834 8.45944 16.2929 8.84996L14.8571 10.2857M12.7143 8.14286L14.8571 10.2857",
    stroke: "#1E232C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditConfig);
export default __webpack_public_path__ + "static/media/editConfig.a972fe3882bfb09e5347ace552bbc466.svg";
export { ForwardRef as ReactComponent };